module.exports = __webpack_public_path__ + "10148440221da3f095e3d73905880661.svg";